import { type PermissionAction, type PermissionResource } from '../model/types';

// Permissions are `${Resource}:${Action}` — check the exact action, not just the resource.
// `Cards:Write` does NOT grant `Cards:Read`.
export const hasPermission = (
  permissions: string[],
  resource: PermissionResource,
  action: PermissionAction,
) => permissions.includes(`${resource}:${action}`);
